// Copyright 2018 Sorama B.V.

import {
    autoinject,
    bindable,
    computedFrom,
    containerless,
    customElement,
    Disposable,
    observable,
    TaskQueue,
} from "aurelia-framework";
import { GenericMeasurement } from "datatypes/SoramaWebApi";
import { MeasurementColorService } from "services/Color/MeasurementColorService";
import { NamedColor } from "services/Color/NamedColor";

@autoinject
@customElement("measurement-color-picker")
@containerless
export class MeasurementColorPicker {
    private colorService: MeasurementColorService;

    private colorSubDisposable: Disposable;

    @bindable
    public measurement: GenericMeasurement;

    @bindable
    public subIndex = "";

    @observable
    protected selectedColor: NamedColor;

    @computedFrom("selectedColor", "measurement")
    protected get iconTitle(): string {
        if (!this.measurement || !this.selectedColor) return "";
        return (
            (this.selectedColor.name
                ? "The current color for '" + this.measurement.name + "' is " + this.selectedColor.name + ". "
                : "") + "Click to assign a different color."
        );
    }

    constructor(colorService: MeasurementColorService, taskQueue: TaskQueue) {
        this.colorService = colorService;
    }

    public bind(): void {
        this.measurementChanged();
    }

    public unbind(): void {
        if (this.colorSubDisposable) {
            this.colorSubDisposable.dispose();
        }
    }

    public measurementChanged(): void {
        if (!this.measurement) return;

        this.colorSubDisposable?.dispose();
        this.colorSubDisposable = this.colorService.subscribe(
            {
                measurementId: this.measurement.id,
                subIndex: this.subIndex,
            },
            (color) => {
                this.selectedColor = color;
            }
        );

        this.selectedColor = this.colorService.ensureAssignedColor({
            measurementId: this.measurement.id,
            subIndex: this.subIndex,
        });
    }

    public selectedColorChanged(color: NamedColor): void {
        if (!this.measurement) return;

        this.selectedColor = this.colorService.ensureAssignedColor(
            {
                measurementId: this.measurement.id,
                subIndex: this.subIndex,
            },
            color
        );
    }
}
